import { render } from "./ModuleInfo.vue?vue&type=template&id=ff825ca2&scoped=true"
import script from "./ModuleInfo.vue?vue&type=script&lang=js"
export * from "./ModuleInfo.vue?vue&type=script&lang=js"

import "./ModuleInfo.vue?vue&type=style&index=0&id=ff825ca2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff825ca2"]])

export default __exports__